const MAX_IMAGE_WIDTH = 2200;

const loadImageElement = (file) => new Promise((resolve, reject) => {
  const objectUrl = URL.createObjectURL(file);
  const image = new Image();

  image.onload = () => {
    URL.revokeObjectURL(objectUrl);
    resolve(image);
  };

  image.onerror = () => {
    URL.revokeObjectURL(objectUrl);
    reject(new Error('Could not load screenshot image.'));
  };

  image.src = objectUrl;
});

const getImageSource = async (file) => {
  if (!file) {
    throw new Error('Missing screenshot file.');
  }

  if (typeof createImageBitmap === 'function') {
    return createImageBitmap(file);
  }

  return loadImageElement(file);
};

const preprocessImage = async (file) => {
  const image = await getImageSource(file);
  const sourceWidth = image.width;
  const sourceHeight = image.height;

  if (!sourceWidth || !sourceHeight) {
    throw new Error('Screenshot image has no readable dimensions.');
  }

  const scale = sourceWidth > MAX_IMAGE_WIDTH ? MAX_IMAGE_WIDTH / sourceWidth : 1;
  const width = Math.round(sourceWidth * scale);
  const height = Math.round(sourceHeight * scale);
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d', { willReadFrequently: true });

  if (!context) {
    throw new Error('Could not create image preprocessing canvas.');
  }

  canvas.width = width;
  canvas.height = height;
  context.imageSmoothingEnabled = true;
  context.imageSmoothingQuality = 'high';
  context.drawImage(image, 0, 0, width, height);

  if (typeof image.close === 'function') {
    image.close();
  }

  return {
    canvas,
    originalWidth: sourceWidth,
    originalHeight: sourceHeight,
    width,
    height,
    scale,
  };
};

export default preprocessImage;
